import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ApModal from "../../../components/Modal/ApModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";
import DatePicker from "../../../components/DatePicker";

// Model
import { prMasterModel } from "../../../../model/Purchase/PrMasterModel";
import { prDetailModel } from "../../../../model/Purchase/PrDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getSpRunNumber,
  randomDelay,
  deleteData,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import EmployeeModal from "../../../components/Modal/EmployeeModal";

function Form({ callInitialize, mode, setMode, name, maxDocNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState(prMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [empDataList, setEmpDataList] = useState([]);
  const [deptDataList, setDeptDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // ใช้สำหรับตั้งตัวแปรรับข้อมูลแผนกผู้ขอซื้อ
  const [deptName, setDeptName] = useState("");

  // ใช้สำหรับเลือกประเภทการขอซื้อ (1 = แผนกเดียว, 2 = หลายแผนก)
  const [purchaseType, setPurchaseType] = useState("1");

  // เก็บ Dept_Id ของผู้ขอซื้อ เพื่อใช้บันทึก Emp_Dept ใน PR_D เมื่อเป็น "ขอซื้อแผนกเดียว"
  const [prByDeptId, setPrByDeptId] = useState(null);

  // ใช้สำหรับเก็บแผนกที่เลือกใน ItemModal
  const [selectedDeptInModal, setSelectedDeptInModal] = useState(null);

  // ใช้สำหรับ Checkbox แสดงรายการสินค้าทั้งหมด (Default ไว้ให้คุณดาด้าเป็นติ๊กถูกไว้)
  const [showAllItems, setShowAllItems] = useState(true);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      const empDataList = await getDataWithComp(
        "View_Set_Employee",
        `AND Emp_Status = 'Y' ORDER BY Emp_Code ASC`
      );
      if (empDataList && empDataList.length > 0) {
        setEmpDataList(empDataList);
      }

      // ดึงข้อมูลแผนก
      const deptResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/get-tb-set-dept`,
        {},
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      if (deptResponse.data && deptResponse.data.length > 0) {
        setDeptDataList(deptResponse.data);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList);

        const findIdByNo = await getDataWithComp(
          "PR_H",
          `AND Doc_No = '${maxDocNo}'`
        );

        // ค้นหาไฟล์ที่เกี่ยวข้อง (ปรับแต่งใหม่)
        if (findIdByNo[0].Doc_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 1 AND Doc_ID = ${findIdByNo[0].Doc_Id}`
          );

          if (Array.isArray(image) && image.length > 0) {
            setSelectedFiles(image);
          } else {
            setSelectedFiles([]);
          }
        } else {
          setSelectedFiles([]);
        }
      }

      // Default สินค้าของโรงน้ำแข็ง ตาม DocType
      if (mode === "I") {
        await handleChangeMaster({ target: { name: "docType", value: "1" } });
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList) => {
    try {
      // ดึงข้อมูลเอกสารจาก PR_H
      const [findMaster] = await Promise.all([getDataWithComp("PR_H", "")]);
      const fromDatabase = findMaster.find((pr) => pr.Doc_No === maxDocNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ดึงข้อมูลผู้ขายจาก apDataList โดยใช้ AP_ID
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === fromDatabase.AP_ID
      );

      if (!fromViewAp) {
        throw new Error("ไม่พบข้อมูลผู้ขาย");
      }

      // ดึงข้อมูลจาก VIEW API_0101_PR_H
      const [findViewMaster] = await Promise.all([
        getDataWithComp("API_0101_PR_H", ""),
      ]);
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.docsetcolour);
      setDeptName(fromView.Dept_Name);

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (itemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...prDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: itemSelected.Item_Desc,
          empDept: itemSelected.Emp_Dept,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "PR_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );
        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate: fromDatabase.Doc_Date || null,
          docDueDate: fromDatabase.Doc_DueDate || null,
          docStatus: fromDatabase.Doc_Status,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPO: fromDatabase.Doc_Is_PO,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          apID: fromDatabase.AP_ID,
          apCode: fromDatabase.AP_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          prById: fromDatabase.PR_By_Id,
          prByCode: fromView.Emp_Code,
          prByName: fromView.Emp_Name,

          // ข้อมูลผู้ขาย
          apName: fromViewAp.AP_Name,
          apAdd1: fromViewAp.AP_Add1,
          apAdd2: fromViewAp.AP_Add2,
          apAdd3: fromViewAp.AP_Add3,
          apProvince: fromViewAp.AP_Province,
          apZipcode: fromViewAp.AP_Zipcode,
          apTaxNo: fromViewAp.AP_TaxNo,
        });

        setPurchaseType(fromDatabase.PR_Type ? String(fromDatabase.PR_Type) : "1");

        // เก็บ Dept_Id ของผู้ขอซื้อ (กรณีเปิดดู/แก้ไข) เพื่อให้การบันทึก PR_D ใช้ค่าแผนกได้
        try {
          const deptIdLoaded = await getDepartmentForEmp(fromDatabase.PR_By_Id);
          setPrByDeptId(deptIdLoaded);
        } catch (err) {
          // ไม่บล็อกถ้าเรียกหาแผนกล้มเหลว
        }

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleSubmit = async () => {
    try {
      // หากยังไม่มี prByDeptId แต่เป็น single-dept และมีผู้ขอซื้อ ให้พยายามดึงแผนกอีกครั้ง
      let deptIdToUse = prByDeptId;

      if (purchaseType === "1" && !deptIdToUse && formMasterList.prById) {
        try {
          const deptLookup = await getDepartmentForEmp(formMasterList.prById);

          deptIdToUse = deptLookup;
          setPrByDeptId(deptIdToUse);
        } catch (err) {
          // ถ้าดึงไม่สำเร็จ ให้ปล่อยต่อไป (จะ fallback เป็น item.empDept หรือ null)
        }
      }
      await randomDelay();

      const newMaxDoc = await getSpRunNumber("PR");
      if (!newMaxDoc) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      if (!formMasterList.apID && !formMasterList.apCode) {
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return;
      }

      if (!formMasterList.prById) {
        getAlert("FAILED", "กรุณาเลือกผู้ขอซื้อ");
        return;
      }

      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return;
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return;
        }
        if (purchaseType === "2" && item.empDept === null) {
          getAlert("FAILED", `กรุณาเลือกแผนกของสินค้า ${item.itemName}`);
          return;
        }
      }

      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency("1", 10),
        doc_code: parseCurrency("1", 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        doc_is_po: parseCurrency("0", 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        pr_by_id: parseCurrency(formMasterList.prById, 10),
        pr_type: parseCurrency(purchaseType, 10),
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pr-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "PR_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1")
                  : parseCurrency("2"),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1"),
              wh_id: parseCurrency(item.whId),
              zone_id: parseCurrency("1"),
              lt_id: parseCurrency("1"),
              ds_seq: formatDateTime(new Date()),
              item_desc: item.itemDesc,
              emp_dept:
                purchaseType === "1"
                  ? deptIdToUse
                    ? parseCurrency(deptIdToUse, 10)
                    : item.empDept
                      ? parseCurrency(item.empDept, 10)
                      : null
                  : item.empDept
                    ? parseCurrency(item.empDept, 10)
                    : null,
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pr-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          if (selectedFiles.length > 0) {
            try {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: docId,
                  DocCode_ID: 1,
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: selectedFiles,
                  doc_no_ref: null,
                }
              );
              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            } catch (error) {
              getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
            }
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // หากยังไม่มี prByDeptId แต่เป็น single-dept และมีผู้ขอซื้อ ให้พยายามดึงแผนกอีกครั้ง
      let deptIdToUse = prByDeptId;
      if (purchaseType === "1" && !deptIdToUse && formMasterList.prById) {
        try {
          deptIdToUse = await getDepartmentForEmp(formMasterList.prById);
          setPrByDeptId(deptIdToUse);
        } catch (err) {
          // ไม่บล็อกการอัปเดต
        }
      }
      if (!formMasterList.apID && !formMasterList.apCode) {
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return;
      }

      if (!formMasterList.prById) {
        getAlert("FAILED", "กรุณาเลือกผู้ขอซื้อ");
        return;
      }

      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return;
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return;
        }
        if (purchaseType === "2" && item.empDept === null) {
          getAlert("FAILED", `กรุณาเลือกแผนกของสินค้า ${item.itemName}`);
          return;
        }
      }

      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_code: parseCurrency(formMasterList.docCode, 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_po: parseCurrency(formMasterList.docIsPO, 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(
          formMasterList.discountValueType,
          10
        ),
        discount_cash: parseCurrency(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
        pr_by_id: parseCurrency(formMasterList.prById, 10),
        pr_type: parseCurrency(purchaseType, 10),
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pr-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        await deleteData("PR_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseCurrency(formMasterList.docId, 10);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype: item.itemDisType,
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency(item.zoneId, 10),
            lt_id: parseCurrency(item.ltId, 10),
            ds_seq: item.dsSeq,
            item_desc: item.itemDesc,
            emp_dept:
              purchaseType === "1"
                ? deptIdToUse
                  ? parseCurrency(deptIdToUse, 10)
                  : item.empDept
                    ? parseCurrency(item.empDept, 10)
                    : null
                : item.empDept
                  ? parseCurrency(item.empDept, 10)
                  : null,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pr-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        if (selectedFiles.length > 0) {
          try {
            const filteredFiles = selectedFiles.filter((file) => {
              if (typeof file === "string") {
                return false;
              }
              return file && typeof file === "object" && file.isPending;
            });

            if (filteredFiles.length > 0) {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: docId,
                  DocCode_ID: 1,
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: filteredFiles,
                  doc_no_ref: null,
                }
              );

              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            }
          } catch (error) {
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pr-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = async (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));

    // ใบขอซื้อ เมื่อเลือกประเภทเอกสารแล้ว ตอนเพิ่มสินค้าให้กรองเฉพาะสินค้า ตามกลุ่มสินค้าที่กำหนดไว้
    if (localStorage.getItem("company") === "1" && name === "docType") {
      // กำหนด mapping itemGroup สำหรับแต่ละประเภทเอกสาร
      const itemGroupMapping = {
        1: ["11", "12", "13", "14", "15", "16", "17", "18", "19"], // ซื้อสินค้า
        2: ["12", "14", "18"], // บริการ
        3: ["11", "12", "13", "14", "15", "16", "17", "18", "19"], // โปรเจค
        4: ["11", "12", "13", "14", "15", "16", "17", "18", "19"], // ของขวัญ
        5: ["11", "12", "13", "14", "15", "16", "17", "18", "19"], // โอที
      };

      const itemGroups = itemGroupMapping[value];

      if (itemGroups) {
        try {
          // ตามที่พี่คินแจ้งมา
          const itemDataList = await getDataWithComp(
            "Tb_Set_Item",
            `AND Item_Group IN ('${itemGroups.join(
              "','"
            )}') AND Item_Status = 'Y' ORDER BY Item_Code ASC`
          );

          if (itemDataList && itemDataList.length > 0) {
            setItemDataList(itemDataList);
          }
        } catch (error) {
          getAlert("FAILED", error.response?.data?.message || error.message);
        }
      } else {
        try {
          // ถ้าไม่มีการเลือกประเภทเอกสาร หรือกรณี default ให้ดึงข้อมูลทั้งหมด
          const itemDataList = await getViewItem();

          if (itemDataList && itemDataList.length > 0) {
            setItemDataList(itemDataList);
          }
        } catch (error) {
          getAlert("FAILED", error.response?.data?.message || error.message);
        }
      }
    } else if (
      localStorage.getItem("company") === "2" &&
      name === "docType" &&
      !showAllItems
    ) {
      await loadItemsByDocTypeForIce(value);
    }
  };

  const handleShowAllItems = async (newValue) => {
    setShowAllItems(newValue);
    if (newValue) {
      try {
        const itemDataList = await getViewItem();
        if (itemDataList && itemDataList.length > 0) {
          setItemDataList(itemDataList);
        }
      } catch (error) {
        getAlert("FAILED", error.response?.data?.message || error.message);
      }
    } else {
      await loadItemsByDocTypeForIce(formMasterList.docType);
    }
  };

  const loadItemsByDocTypeForIce = async (docType) => {
    // กำหนด mapping itemGroup สำหรับแต่ละประเภทเอกสาร
    const itemGroupMapping = {
      1: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
      ], // ซื้อสินค้า
      2: ["23", "24", "25", "26", "27"], // บริการ
      3: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
      ], // โปรเจค
      4: ["28"], // ของขวัญ
      5: ["25"], // โอที
    };

    const itemGroups = itemGroupMapping[docType];

    if (itemGroups) {
      try {
        // ตามที่พี่คินแจ้งมา
        const itemDataList = await getDataWithComp(
          "Tb_Set_Item",
          `AND Item_Group IN ('${itemGroups.join(
            "','"
          )}') AND Item_Status = 'Y' ORDER BY Item_Code ASC`
        );

        if (itemDataList && itemDataList.length > 0) {
          setItemDataList(itemDataList);
        }
      } catch (error) {
        getAlert("FAILED", error.response?.data?.message || error.message);
      }
    } else {
      try {
        // ถ้าไม่มีการเลือกประเภทเอกสาร หรือกรณี default ให้ดึงข้อมูลทั้งหมด
        const itemDataList = await getViewItem();

        if (itemDataList && itemDataList.length > 0) {
          setItemDataList(itemDataList);
        }
      } catch (error) {
        getAlert("FAILED", error.response?.data?.message || error.message);
      }
    }
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : "",
    }));
  };

  const handleChangeDetail = (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (field !== "itemDesc" && !/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    let numericValue = parseCurrency(value.replace(/,/g, "")) || 0;

    const formattedValue = formatCurrency(
      numericValue,
      field === "itemQty" || field === "itemPriceUnit"
    );

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  const getDepartmentForEmp = async (empId) => {
    try {
      const department = await getDataWithComp(
        "View_Set_Employee",
        `AND Emp_Id = ${empId}`
      );

      if (department && department.length > 0) {
        const row = department[0];
        // Log available keys to help debugging


        // Try common column names first
        let deptId = row.Dept_Id ?? row.DeptID ?? row.Dept_ID ?? row.DeptId ?? row.DEPT_ID ?? null;
        let deptName = row.Dept_Name ?? row.DeptName ?? row.Dept ?? null;

        // If not found, search any key that contains 'dept' (case-insensitive)
        if (!deptId) {
          for (const [k, v] of Object.entries(row)) {
            if (/dept/i.test(k) && v != null && v !== "") {
              // prefer numeric-like ids
              const n = Number(v);
              if (!Number.isNaN(n)) {
                deptId = n;
                break;
              } else {
                deptId = v;
                break;
              }
            }
          }
        }

        // If deptName not found, try keys that include both 'dept' and 'name' or fallback to any 'name'
        if (!deptName) {
          for (const [k, v] of Object.entries(row)) {
            if (/dept.*name/i.test(k) && v) {
              deptName = v;
              break;
            }
          }
          if (!deptName) {
            for (const [k, v] of Object.entries(row)) {
              if (/name/i.test(k) && /dept/i.test(k) === false && v && String(v).toLowerCase().includes("dept") === false) {
                // don't accidentally pick unrelated name fields; prefer Dept_Name-like fields
                // skip
              }
            }
          }
        }

        if (deptId) setPrByDeptId(deptId);
        if (deptName) setDeptName(deptName);
        return deptId ?? null;
      }
      return null;
    } catch (error) {
      getAlert("FAILED", error);
      return null;
    }
  };

  // Upload File
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };
  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          id: Date.now(),
          name: file.name,
          type: file.type,
          size: file.size,
          file: file,
          dataUrl: e.target.result,
          isPending: true,
          displayName: file.name,
        };
        setSelectedFiles((prev) => [...prev, fileData]);
      };
      reader.readAsDataURL(file);
    }
  }
  const handleBeforeUploadAttach = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  // SET EMP
  const [showEmpModal, setShowEmpModal] = useState(false);
  const handleEmpShow = () => setShowEmpModal(true);
  const handleEmpClose = () => setShowEmpModal(false);
  const onRowSelectEmp = async (empSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        prById: empSelected.Emp_Id,
        prByCode: empSelected.Emp_Code,
        prByName: empSelected.Emp_Name,
      });

      // ค้นหาแผนกผู้ขอซื้อ
      const deptId = await getDepartmentForEmp(empSelected.Emp_Id);
      setPrByDeptId(deptId);

      handleEmpClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      });
      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => {
    setShowItemModal(false);
    setSelectedDeptInModal(null); // รีเซ็ตการเลือกแผนก
  };
  const onRowSelectItem = async (itemsSelected) => {
    try {
      // หาแผนกของผู้ขอซื้อ
      let empDeptId = null;
      if (purchaseType === "1" && formMasterList.prById) {
        empDeptId = await getDepartmentForEmp(formMasterList.prById);
      }

      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemDesc: null,
            empDept: purchaseType === "2" ? selectedDeptInModal : empDeptId,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(Number(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grand = Number((subFinal + vatAmount).toFixed(2));
    setGrandTotal(grand);
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/purchase-request" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("pr", formMasterList.docNo)}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
      />
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={handleChangeDateMaster}
              disabled={formMasterList.docStatus !== 1}
              docStatus={formMasterList.docStatus}
            />
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.apCode || "") +
                    " " +
                    (formMasterList.apName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  disabled={formMasterList.docStatus !== 1}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={formMasterList.docStatus !== 1}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.apAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={formMasterList.docStatus !== 1}
              >
                <option value="1">ซื้อมาเพื่อใช้</option>
                <option value="2">ซื้อมาเพื่อขาย</option>
              </select>
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={formMasterList.docStatus !== 1}
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apProvince || "") +
                  " " +
                  (formMasterList.apZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex">
              <label>ผู้ขอซื้อ</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.prByCode || "") +
                    " " +
                    (formMasterList.prByName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleEmpShow}
                  disabled={formMasterList.docStatus !== 1}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <EmployeeModal
                showEmpModal={showEmpModal}
                handleEmpClose={handleEmpClose}
                empDataList={empDataList}
                onRowSelectEmp={onRowSelectEmp}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.apTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่อนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedDate"
                value={formMasterList.approvedDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>แผนก</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={deptName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label style={{ marginBottom: 0 }}>ประเภทการขอซื้อ</label>
              <select
                className="form-select form-control input-spacing"
                name="purchaseType"
                value={purchaseType}
                onChange={(e) => setPurchaseType(e.target.value)}
                disabled={formMasterList.docStatus !== 1}
              >
                <option value="1">ขอซื้อแผนกเดียว</option>
                <option value="2">ขอซื้อหลายแผนก</option>
              </select>
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้อนุมัติเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={formMasterList.approvedByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-6"></div>
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>หมายเหตุอนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedMemo"
                value={formMasterList.approvedMemo || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={formMasterList.docStatus !== 1}
            showAllItems={showAllItems}
            handleShowAllItems={async (value) => handleShowAllItems(value)}
            deptDataList={deptDataList}
            purchaseType={purchaseType}
            selectedDeptInModal={selectedDeptInModal}
            setSelectedDeptInModal={setSelectedDeptInModal}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={formMasterList.docStatus !== 1}
          />
        </div>
      </div>

      <br />

      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        setMode={setMode}
        disabled={formMasterList.docStatus === 13}
        footer={true}
      />
    </>
  );
}

export default Form;
